import request from '@/utils/request'

// OA接口：

// 新增车辆：post oa/createCar，参数：
// title // 标题
// text // 备注
// order // 排序
export function createCar(data) {
    return request({
      url: '/oa/createCar',
      method: 'post',
      data,
    })
  }

// 修改车辆：post oa/updateCar，参数：
// carId // 车辆ID
// title // 标题
// text // 备注
// order // 排序
export function updateCar(data) {
    return request({
      url: '/oa/updateCar',
      method: 'post',
      data,
    })
  }

// 删除车辆：post oa/removeCar，参数：
// gameId // 游戏ID
export function removeCar(data) {
    return request({
      url: '/oa/removeCar',
      method: 'post',
      data,
    })
  }

// 获取车辆列表：post oa/findCarList，参数：
// keyword // 关键词，匹配标题
export function findCarList(params) {
    return request({
      url: '/oa/findCarList',
      method: 'get',
      params,
    })
  }

// 删除车辆出场记录：post oa/removeCarRecord，参数：
// gameId // 游戏ID
export function removeCarRecord(data) {
    return request({
      url: '/oa/removeCarRecord',
      method: 'post',
      data,
    })
  }

// 获取车辆出场记录列表：post oa/findCarRecordList，参数：
// keyword // 关键词，匹配标题
export function findCarRecordList(params) {
    return request({
      url: '/oa/findCarRecordList',
      method: 'get',
      params,
    })
  }

// 删除人员出场记录：post oa/removePeopleRecord，参数：
// gameId // 游戏ID
export function removePeopleRecord(data) {
    return request({
      url: '/oa/removePeopleRecord',
      method: 'post',
      data,
    })
  }

// 获取人员出场记录列表：post oa/findPeopleRecordList，参数：
// keyword // 关键词，匹配标题
export function findPeopleRecordList(params) {
    return request({
      url: '/oa/findPeopleRecordList',
      method: 'get',
      params,
    })
  }
  
// 获取人员请假天数
export function removeVacation(data) {
  return request({
    url: '/oa/removeVacation',
    method: 'post',
    data,
  })
}

export function findVacationList(params) {
  return request({
    url: '/oa/findVacationList',
    method: 'get',
    params,
  })
}
export function createVacation(data) {
  return request({
    url: '/oa/createVacation',
    method: 'post',
    data,
  })
}
export function updateVacation(data) {
  return request({
    url: '/oa/updateVacation',
    method: 'post',
    data,
  })
}

export function findPatrolRecordList(params) {
  return request({
    url: '/oa/findPatrolRecordList',
    method: 'get',
    params,
  })
}
export function findVisitorRecordList(params) {
  return request({
    url: '/oa/findVisitorRecordList',
    method: 'get',
    params,
  })
}